/** Fondu enchaîné entre deux pistes : la piste courante monte vers 1, la sortante descend vers 0 puis s'arrête. Pur, piloté par `update(dt)`. */
export interface FadeLevel { key: string; level: number; }
export interface FadeOutput { set: FadeLevel[]; stop: string[]; }

export class Crossfade {
  private current: { key: string; level: number } | null = null;
  private outgoing: { key: string; level: number } | null = null;
  constructor(private readonly durationMs = 800) {}

  get currentKey(): string | null { return this.current?.key ?? null; }

  /** Passe à `key` (`null` = silence). Même piste : rien. Une piste déjà en sortie est arrêtée tout de suite (`stop`). */
  start(key: string | null): FadeOutput {
    if ((this.current?.key ?? null) === key) return { set: [], stop: [] };
    const stop: string[] = [];
    const set: FadeLevel[] = [];
    if (this.outgoing) {
      // la sortante s'arrête net, sauf si on revient dessus : elle redevient courante en remontant
      if (this.outgoing.key === key) { const back = this.outgoing; this.outgoing = this.current; this.current = back; return { set, stop }; }
      stop.push(this.outgoing.key);
      this.outgoing = null;
    }
    this.outgoing = this.current;
    this.current = key === null ? null : { key, level: 0 };
    if (this.current) set.push({ ...this.current });
    return { set, stop };
  }

  update(dtMs: number): FadeOutput {
    const step = this.durationMs > 0 ? dtMs / this.durationMs : 1;
    const set: FadeLevel[] = [];
    const stop: string[] = [];
    if (this.current && this.current.level < 1) {
      this.current.level = Math.min(1, this.current.level + step);
      set.push({ ...this.current });
    }
    if (this.outgoing) {
      this.outgoing.level = Math.max(0, this.outgoing.level - step);
      if (this.outgoing.level <= 0) { stop.push(this.outgoing.key); this.outgoing = null; } else set.push({ ...this.outgoing });
    }
    return { set, stop };
  }
}
